import Vue from "vue";

import ConfigPlugin from '../configPlugin';
Vue.use(ConfigPlugin);

import VueRouter from "vue-router";
import routes from "./routes";
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {

    let isLoggedIn = false;

    if(Vue.$cookies.get('token') !== null && Vue.$cookies.get('moniker') !== null) {
        isLoggedIn = true;
        router.app.$updateConfigVariables({ moniker: Vue.$cookies.get('moniker') });
        router.app.$updateConfigVariables({ user: Vue.$cookies.get('user') });

        let sites = JSON.parse(localStorage.getItem("sites"));
        router.app.$updateConfigVariables({ sites: sites });

    } else {
        // Remove saved data from sessionStorage
        localStorage.removeItem("sites");
    }    
    
    if (to.name !== "login" && !isLoggedIn) {
      return next({ path: "/login" });
    }

    if (to.name === "logout") {
        Vue.$cookies.remove('token');
        return next({ path: "/login" });
    } 

    next();

  });
  

export default router;
